import Noty from 'noty';

const notify = (text, timeout, type) => {
  new Noty({
    theme: 'custom',
    layout: 'bottomLeft',
    type: type,
    text: text,
    timeout: timeout,
    progressBar: false,
  }).show();
};

export default {
  info: (text, timeout = 3000) => notify(text, timeout, 'info'),
  warn: (text, timeout = 3000) => notify(text, timeout, 'warning'),
  success: (text, timeout = 3000) => notify(text, timeout, 'success'),
  error: (text, timeout = 3000) => notify(text, timeout, 'error'),
};
